import WelcomeShareScreen from "./WelcomeShareScreen";
export default WelcomeShareScreen;
